import React from 'react';
import { ShieldCheckIcon, CreditCardIcon, MailIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-transparent py-8" data-id="element-37" data-mp="3udfc7a8y1rnh">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-38" data-mp="3ueqbawrg2b89">
        <div className="flex flex-wrap justify-center items-center gap-6 mb-5" data-id="element-39" data-mp="c7k43tn1wfmr">
          <div className="flex items-center gap-2 text-gray-400" data-id="element-40" data-mp="84xiiagz3qy0">
            <ShieldCheckIcon className="w-6 h-6 text-[#C084FC]" data-id="element-41" data-mp="m4yjrr15h0e0" />
            <span data-id="element-42" data-mp="m3400g1m7ebi">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400" data-id="element-43" data-mp="h6dhlm2c86mx">
            <CreditCardIcon className="w-6 h-6 text-[#C084FC]" data-id="element-44" data-mp="h412dgnysadk" />
            <span data-id="element-45" data-mp="vu8e7djguv5a">Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}